import { listHref } from "@buildpy/core/modules/list/search";
import { APP_NAV } from "@/shell/nav";

export interface PaletteEntry {
  key: string;
  label: string;
  hint: string;
  href: string;
}

// 목록 화면이 이미 받는 ?q= 로 넘긴다 — 새 검색 백엔드를 두지 않는다. 힌트는 각 목록 검색칸이 찾는 열이다.
export const PALETTE_LISTS: readonly { href: string; name: string; hint: string }[] = [
  { href: "/app/customers", name: "고객", hint: "이름 · 전화 · 현장 주소" },
  { href: "/app/quotes", name: "견적", hint: "견적번호 · 공사명 · 고객 이름" },
  { href: "/app/contracts", name: "계약", hint: "계약번호 · 공사명 · 고객 · 현장 주소" },
  { href: "/app/projects", name: "현장", hint: "현장명 · 현장 주소 · 고객 이름" },
];

// 이름이 맞는 메뉴 먼저, 그다음 목록 찾기 — 빈 검색어면 메뉴 전체만 보인다.
export const paletteEntries = (query: string): PaletteEntry[] => {
  const q = query.trim();
  const needle = q.toLowerCase();
  const menus = APP_NAV.flatMap((group) =>
    group.items
      .filter((item) => !needle || item.name.toLowerCase().includes(needle) || group.label.includes(needle))
      .map((item) => ({ key: `menu:${item.href}`, label: item.name, hint: group.label, href: item.href }))
  );
  if (!q) return menus;
  const searches = PALETTE_LISTS.map((list) => ({
    key: `search:${list.href}`,
    label: `${list.name} 목록에서 「${q}」 찾기`,
    hint: list.hint,
    href: listHref(list.href, { q }),
  }));
  return [...menus, ...searches];
};

interface ShortcutKey {
  key: string;
  code?: string;
  metaKey: boolean;
  ctrlKey: boolean;
  altKey: boolean;
  shiftKey: boolean;
  isComposing?: boolean;
}

// mac 은 Cmd+K 만, 그 밖은 Ctrl+K 만 — mac 입력칸의 Ctrl+K(줄 끝 지우기)를 뺏지 않는다. 한글 자판도 물리 키(KeyK)로 잡는다.
export const isPaletteShortcut = (e: ShortcutKey, mac: boolean): boolean =>
  (mac ? e.metaKey && !e.ctrlKey : e.ctrlKey && !e.metaKey) &&
  !e.altKey &&
  !e.shiftKey &&
  !e.isComposing &&
  (e.code === "KeyK" || e.key.toLowerCase() === "k");

// 단축키가 바꿀 열림 — 열려 있으면 닫고, 다른 창(대화상자·확인창·시트)이 떠 있으면 열지 않는다(null = 그대로 둔다).
export const paletteToggle = (open: boolean, otherModalOpen: boolean): boolean | null => {
  if (open) return false;
  return otherModalOpen ? null : true;
};

// 위·아래 화살표로 고른 줄을 옮긴다 — 끝에서 반대편 끝으로 돈다.
export const movePaletteIndex = (index: number, delta: number, length: number): number =>
  length === 0 ? 0 : (index + delta + length) % length;
